import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function indexTableData({
  peopleList = [],
  onToggleActive,
  onEditClick,
  onDeleteClick,
  onMoveUp,
  onMoveDown,
}) {
  return {
    columns: [
      { Header: "ID", accessor: "id", width: "10%", align: "center" },
      { Header: "Name", accessor: "name", width: "20%", align: "left" },
      { Header: "Description", accessor: "description", width: "40%", align: "left" },
      { Header: "Search Text", accessor: "searchText", width: "50%", align: "left" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: peopleList.map((person, index) => ({
      id: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {person.id}
        </MDTypography>
      ),
      name: (
        <MDBox display="flex" alignItems="center" gap={1}>
          <MDAvatar size="lg">
            <img
              src={person?.imageUrl}
              alt={person?.name}
              style={{
                width: "60%",
                height: "60%",
                objectFit: "contain",
              }}
            />
          </MDAvatar>
          <MDTypography variant="button" fontWeight="medium">
            {person?.name}
          </MDTypography>
        </MDBox>
      ),
      description: (
        <MDTypography variant="button" fontWeight="medium">
          {person?.description}
        </MDTypography>
      ),
      searchText: (
        <MDTypography variant="button" fontWeight="medium">
          {person?.searchText}
        </MDTypography>
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <IconButton
            size="small"
            onClick={() => onMoveUp(index)}
            disabled={index === 0}
            color="info"
          >
            <ArrowUpwardIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => onMoveDown(index)}
            disabled={index === peopleList.length - 1}
            color="info"
          >
            <ArrowDownwardIcon fontSize="small" />
          </IconButton>
          <Switch
            checked={person?.isEnabled}
            onChange={() => onToggleActive(person?.id, person?.isEnabled)}
            color="primary"
          />
          <IconButton size="small" onClick={() => onEditClick(person)}>
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => onDeleteClick(person?.id)}
            sx={{ color: "error.main" }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
